import { useState, useEffect } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';

import { handleLogout } from '../utils/Logout';
import { useAuthStorage } from '../hooks/useAuthStorage';

const ProtectedRoute = ({ children }) => {
  const { getToken } = useAuthStorage();
  const [isAuthenticated, setIsAuthenticated] = useState(null);

  const navigate = useNavigate();

  // Helper function to check if the token exists and is still valid
  const isTokenValid = () => {
    const token = getToken();
    if (!token) return false;

    try {
      // Decode the payload of the JWT
      const tokenPayload = JSON.parse(atob(token.split('.')[1]));
      const currentTime = Math.floor(Date.now() / 1000);

      // Check if the token is still valid based on its expiration time
      return currentTime < tokenPayload.exp;
    } catch (error) {
      console.error('Invalid token format:', error);
      return false;
    }
  };

  useEffect(() => {
    const checkAuth = () => {
      if (!isTokenValid()) {
        handleLogout(navigate);
        setIsAuthenticated(false);
      } else {
        setIsAuthenticated(true);
      }
    };

    checkAuth();

    const interval = setInterval(() => {
      if (!isTokenValid()) {
        handleLogout(navigate);
        setIsAuthenticated(false);
      }
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  if (isAuthenticated === null) return null;
  if (!isAuthenticated) return <Navigate to="/signin" replace />;

  return children;
};

export default ProtectedRoute;
